import React from 'react';
import { motion } from 'framer-motion';

import { sanitizeHtml } from 'utils';

import image_1 from '../../../../../asset/resource/stages-image-1.png';
import image_2 from '../../../../../asset/resource/stages-image-2.png';
import image_3 from '../../../../../asset/resource/stages-image-3.png';

import './EnergyStages.scss';

const EnergyStages = ({ data }) => {
  const { heading, items } = data;

  const sectionAnimation = (moveFrom) => ({
    initial: { opacity: 0, x: moveFrom === 'left' ? -400 : 400 },
    animate: { opacity: 1, x: 0 },
    transition: { ease: 'easeOut', duration: 1.1 },
  });

  return (
    <div className="stages">
      <div className="stages__wrapper">
        <h2 dangerouslySetInnerHTML={{ __html: sanitizeHtml(heading) }} />

        <div className="stages__list">
          <div className="stages__left">
            <motion.div
              className="stages__item"
              initial={{ opacity: 0, x: -400 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ type: 'anticipate', duration: 1.5 }}
            >
              <div className="stages__item-heading">
                <div className="stages__item-image-wrapper">
                  <img className="stages__image stages__image_first" src={image_2} alt="" />
                </div>
                <h3
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(items[1].heading),
                  }}
                />
              </div>
              <div
                className="stages__item-description"
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(items[1].content),
                }}
              />
            </motion.div>
          </div>

          <div className="stages__right">
            <motion.div
              initial={{ opacity: 0, x: 400 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ type: 'anticipate', duration: 1.5 }}
              className="stages__item"
            >
              <div className="stages__item-heading">
                <div className="stages__item-image-wrapper">
                  <img className="stages__image stages__image_second" src={image_1} alt="" />
                </div>
                <h3
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(items[0].heading),
                  }}
                />
              </div>
              <div
                className="stages__item-description"
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(items[0].content),
                }}
              />
            </motion.div>

            <div className="stages__item stages__item_mobile">
              <div className="stages__item-heading">
                <div className="stages__item-image-wrapper">
                  <img className="stages__image stages__image_first" src={image_2} />
                </div>
                <h3>Analysis and Forecasting</h3>
              </div>
              <p>
                Facilitate granular, self-service analyses with data modelling best practices to disaggregate energy,
                detect patterns, and understand peak usage.
                <br />
                <br />
                Develop simulation models drawing on historical and synthetic data to leverage telemetry, failure,
                energy, and consumption forecasting models.
                <br />
                <br />
                Build digital twins to probe “what-if” scenarios and remove obstacles to implementing far-reaching
                energy management projects — equipment-, operation-, system-wide
              </p>
            </div>

            <motion.div
              initial={{ opacity: 0, x: 400 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ type: 'anticipate', duration: 1.5 }}
              className="stages__item"
            >
              <div className="stages__item-heading">
                <div className="stages__item-image-wrapper">
                  <img className="stages__image stages__image_third" src={image_3} alt="" />
                </div>
                <h3
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(items[2].heading),
                  }}
                />
              </div>

              <div
                className="stages__item-description"
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(items[2].content),
                }}
              />
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnergyStages;
